import Vue from 'vue';

export class ServerPicture {

  public static uploadPicture(file: any): Promise<any> {
    return new Promise((resolve) => {
      let formData = new FormData()
      formData.append('file', file.file)

      Vue.axios({
        url: '/media',
        method: 'POST',
        headers: {
          'Content-Type': 'multipart/form-data; charset=utf-8' 
        },
        data: formData
      })

      .then(resp => resolve(resp))
      .catch(err => console.log(err))
    })
  }

  // удаление картинок 
  // keys : []
  public static deletePicture(keys : any): Promise<any> {
    return new Promise((resolve) => {
      Vue.axios({
        url: '/media',
        method: 'DELETE',
        data: {
          'keys': keys
        }
      })

      .then(resp => resolve(resp))
      .catch(err => console.log(err))
    })
  }

  // получение линка картинок 
  // keys : []
  public static getPictureByKeys(keys : any): Promise<any> {
    return new Promise((resolve) => {
      Vue.axios({
        url: '/media-links',
        method: 'POST',
        data: {
          'keys': keys
        }
      })

      .then(resp => resolve(resp))
      .catch(err => console.log(err))
    })
  }
}